import React from 'react';
import { IShapeProps } from './types';
import { IShapeStarAttributes } from '../../../types';
import { Star } from 'react-konva';
import Konva from 'konva';

const StarCanvasElement: React.FC<IShapeProps> = (props) => {

  let attributes = (props.element.attributes as IShapeStarAttributes);
  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Star>);

  return (
    <Star
      {...props.renderProps}
      ref={shapeRef}
      numPoints={attributes.numPoints}
      innerRadius={attributes.innerRadius ?? attributes.width! / 5}
      outerRadius={attributes.outerRadius ?? attributes.width! / 2}
    />
  );
}

export default StarCanvasElement